<template>
  <CustomTable ref="table" :elements=elements :data="data" :searchOptions="searchOptions" :loadData="loadData">
    <template v-slot:header-options>
      <button class="button-icon" title="Actualiser les statuts" @click="refreshIncomingInvoices" style="margin-right: 10px"><span class="fas fa-rotate"></span></button>
    </template>
    <template v-slot:table>
      <thead>
        <tr>
          <custom-header field="invoiceNumber">N°</custom-header>
          <custom-header field="clientName">Nom</custom-header>
          <custom-header field="ttcAmount">Montant TTC</custom-header>
          <custom-header field="amount_due_for_payment">Reste à payer</custom-header>
          <custom-header field="status">Status</custom-header>
          <custom-header field="actions">action</custom-header>
        </tr>
      </thead>
      <tbody v-if="!isLoading && data && data.length > 0">
        <tr v-for="(business, index) in $refs.table.$refs.searchArray.simpleFilter(data)" :key="index">
            <custom-body field="invoiceNumber" class="truncate-cell" :title="business.invoiceNumber">{{ business.invoiceNumber }}</custom-body>
            <custom-body field="clientName" class="truncate-cell" :title="business.clientName">{{ business.clientName }}</custom-body>
            <custom-body field="ttcAmount">{{ business.ttcAmount }}</custom-body>
            <custom-body field="amount_due_for_payment">{{ business.amount_due_for_payment }}</custom-body>
            <custom-body field="status">
              <span class="transmission-status" :title="getTransmissionStatus(business.status)" :style="getTransmissionStatusStyle(business.status)">
                {{ getTransmissionStatus(business.status) }}
              </span>
            </custom-body>
            <custom-body field="actions">
              <button class="button-icon-custom" title="Télécharger" @click="downloadInvoice(business)"><span class="fas fa-download"></span></button>
              <button class="button-icon-custom" title="Actualiser" @click="refreshInvoice(business)"><span class="fas fa-rotate"></span></button>
              <button class="button-icon-custom" title="Historique" @click="this.$refs.invoiceTransmissionHistoryModal.openModal(business.association)"><span class="fas fa-clock-rotate-left"></span></button>
              <button class="button-icon-custom" title="Gérer le statut" @click="this.$refs.invoiceTransmissionStatusModal.openModal(business.association)"><span class="fas fa-pen-to-square"></span></button>
            </custom-body>
        </tr>
      </tbody>
      <tbody v-else><tr class="empty-row">
        <td colspan="6" class="hide-for-mobile">Aucun contrat enregistré</td>
      </tr></tbody>
    </template>
  </CustomTable>
  <InvoiceTransmissionHistoryModal ref="invoiceTransmissionHistoryModal"/>
  <InvoiceTransmissionStatusModal ref="invoiceTransmissionStatusModal"/>
</template>

<script>
import {BUSINESS_STATUS_ENUM} from "@/models/businessStatusEnum";
import CustomTable from "@/components/CustomTable.vue";
import CustomHeader from "@/components/tables/CustomHeader.vue";
import CustomBody from "@/components/tables/CustomBody.vue";
import { InvoiceTransmissionAssociationController} from "@/invoice-transmission/controllers/invoice_transmission/InvoiceTransmissionAssociationController";
import InvoiceTransmissionHistoryModal from "@/invoice-transmission/components/modals/InvoiceTransmissionHistoryModal.vue";
import {getTransmissionStatus, getTransmissionStatusStyle} from "../../utils";
import InvoiceTransmissionStatusModal from "@/invoice-transmission/components/modals/InvoiceTransmissionStatusModal.vue";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPenToSquare, faDownload } from "@fortawesome/free-solid-svg-icons";
import {InvoiceController} from "@/invoice-transmission/controllers/invoice_transmission/InvoiceController";
import {NotificationService} from "@vues/v-common";
library.add(faPenToSquare);
library.add(faDownload);

export default {
  name: 'IncomingInvoiceTransmissionTable',
  computed: {
    BUSINESS_STATUS_ENUM() {
      return BUSINESS_STATUS_ENUM
    }
  },
  components: {
    InvoiceTransmissionStatusModal,
    InvoiceTransmissionHistoryModal,
    CustomBody,
    CustomHeader,
    CustomTable
  },
  data: function () {
    return {
      data: [],
      elements: [
        {label: "Actions", value: undefined, type: undefined}
      ],
      searchOptions: {
        filters: [],
        sorts: []
      },
      isLoading: true,
      refusedOrAbortedBusinessVisibility: false,
      currentChoice: undefined
    }
  },
  async mounted() {
    this.$refs.table.$refs.searchArray.initWithURLParams();

    await this.loadData();
  },
  methods: {
    getTransmissionStatusStyle,
    getTransmissionStatus,
    async loadData(){
      this.$refs.table?.startLoading();
      this.isLoading = true;
      this.data = [];

      const resp = await InvoiceTransmissionAssociationController.getIncomingInvoiceAssociationTable(this.$refs.table.buildURLParams());

      if(resp && !resp.errors){
        this.data.push(...resp);
      }

      this.isLoading = false;
      this.$refs.table?.stopLoading();
    },
    // Télécharge le fichier de la facture reçue (PDF ou XML selon ce que le fournisseur a déposé sur la plateforme)
    async downloadInvoice(business){
      const providerInvoiceId = business.providerInvoiceId ?? business.association?.providers?.superpdp?.providerInvoiceId;
      if(!providerInvoiceId){
        (new NotificationService).addNotification("danger", "Identifiant de la facture introuvable, actualisez la liste.");
        return;
      }

      const file = await InvoiceController.download(providerInvoiceId);

      if(!(file instanceof Blob) || file.type.includes("json")){
        (new NotificationService).addNotification("danger", "Impossible de télécharger la facture.");
        return;
      }

      const extension = file.type.includes("pdf") ? "pdf" : "xml";
      const supplier = business.clientName ? "_" + business.clientName.replaceAll(' ', '_').replace(/[<>:|?*\\/]/g, '') : '';
      const url = URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Facture_${business.invoiceNumber}${supplier}.${extension}`;
      a.click();
      URL.revokeObjectURL(url);
    },
    async refreshInvoice(business){
      this.$refs.table?.startLoading();

      const resp = await InvoiceController.refresh(business.associationId);

      if(resp && !resp.errors){
        await this.loadData();
      }

      this.$refs.table?.stopLoading();
    },
    async refreshIncomingInvoices(){
      this.$refs.table?.startLoading();
      this.isLoading = true;

      await InvoiceTransmissionAssociationController.refreshIncomingInvoices();
      await this.loadData();

      this.isLoading = false;
      this.$refs.table?.stopLoading();
    }
  }
}
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';

  .truncate-cell
    overflow hidden
    text-overflow ellipsis
    white-space nowrap

  .transmission-status
    max-width 100%
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    vertical-align middle
    box-sizing border-box
    display inline-block
    padding 4px 10px
    border-radius 20px
    font-size 12px
    font-weight bold
</style>
